import * as Yup from "yup";

export const propertySchema = Yup.object({
  name: Yup.string().required("Required"),
  location: Yup.string().required("Required"),
  owner: Yup.string().required("Required"),
});
